import { t } from 'i18next';
import { useEffect } from 'react';
import AgreementPD from '../apps/Agreement/components/AgreementPD';
import AgreementService from '../apps/Agreement/components/AgreementService';
import { useGetProfileQuery, useLazyGetAccountAgreementQuery } from '../services/users_v1';
import NotFoundPage from './NotFoundPage';

function AgreementPage() {
    useEffect(() => { document.title = `${t('Mediabaza')} - ${t('Agreement')}`; }, [t]);

    const { data: profile, error: profileError } = useGetProfileQuery(undefined);
    const [fetchAccountAgreement, { data: accountAgreement }] = useLazyGetAccountAgreementQuery();

    useEffect(() => {
        if (profile?.results.pd_agreement) {
            fetchAccountAgreement();
        }
    }, [profile]);

    let content = <NotFoundPage />;
    if (accountAgreement?.results.agr_offer) {
        content = <NotFoundPage />
    } else if (profile?.results.pd_agreement) {
        content = <AgreementService profileError={profileError} />
    } else {
        content = <AgreementPD profileError={profileError} />
    }

    return content;
}

export default AgreementPage;
